<div class="dialog-wrapper" [formGroup]="form">

  <button class="close-btn" type="button" (click)="cancel()" aria-label="Cerrar">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18" stroke="#2C2A29" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M6 6L18 18" stroke="#2C2A29" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="titulo">
    <img src="assets/agricola/action-cancel.svg" class="titulo-mask" alt="" aria-hidden="true">
    <div class="titulo-texto">
      <h2 class="titulo-copy">Solicitar cancelación</h2>
      <p class="titulo-sub">Cancelación de póliza a solicitud del afiliado</p>
    </div>
  </div>

  <div class="fields">

    <!-- Código de asistencia | Fecha de cancelación -->
    <div class="linea">
      <div class="field-col">
        <app-sis-field label="Código de asistencia" formControlName="assistanceCode"></app-sis-field>
      </div>
      <div class="field-col">
        <app-sis-date-field label="Fecha de cancelación *" formControlName="cancellationDate"></app-sis-date-field>
      </div>
    </div>

    <!-- Tipología | Subtipología -->
    <div class="linea">
      <div class="field-col">
        <app-sis-select
          label="Tipología *"
          placeholder="Selecciona"
          [options]="typologyOptions"
          formControlName="typologyId">
        </app-sis-select>
      </div>
      <div class="field-col">
        <app-sis-select
          label="Subtipología *"
          placeholder="Selecciona"
          [options]="subtypologyOptions"
          formControlName="subtypologyId">
        </app-sis-select>
      </div>
    </div>

    <!-- Agencia (ancho completo) -->
    <div class="linea">
      <div class="field-col field-col--full">
        <app-sis-select
          label="Agencia"
          placeholder="Selecciona"
          [options]="agencyOptions"
          formControlName="agencyCode">
        </app-sis-select>
      </div>
    </div>

    <!-- Notas (ancho completo) -->
    <div class="field-textarea">
      <span class="textarea-label">Notas *</span>
      <textarea class="notes-input" formControlName="notes" placeholder="máx. 300 caracteres" rows="3"></textarea>
    </div>

  </div>

  <div class="cta-group">
    <button class="cta cta--outline" type="button" (click)="cancel()">Cancelar</button>
    <button
      class="cta cta--primary"
      type="button"
      (click)="onSubmit()"
      [disabled]="form.invalid || isSubmitting">
      {{ isSubmitting ? 'Enviando...' : 'Guardar' }}
    </button>
  </div>

</div>
